import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CategoryPage.css';

const baseUrl = process.env.REACT_APP_BASE_URL;

function CategoryPage() {
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}/ivr/display-categories/English`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        setCategories(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchLanguages = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}/language`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        setLanguages(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
    fetchLanguages()
      .then(() => {
        let selectedLanguageFromStorage = localStorage.getItem('currentLanguage');
        if (selectedLanguageFromStorage) {
          setSelectedLanguage(selectedLanguageFromStorage);
        } else {
          if (!selectedLanguage) {
            selectedLanguageFromStorage = 'Hindi';
            setSelectedLanguage(selectedLanguageFromStorage)
            localStorage.setItem('currentLanguage', selectedLanguageFromStorage);
          }
        }
      });
  }, []);

  const handleCategoryClick = (category) => {
    localStorage.setItem('currentCategory', category);
  };

  const handleLanguageChange = async (event) => {
    console.log(event.target);
    const lang = event.target.value;
    setSelectedLanguage(lang);
    localStorage.setItem('currentLanguage', lang);
  };

  return (
    <div className='container' style={{ padding: '20px', textAlign: 'center' }}>
      <div className="d-flex flex-md-row flex-column align-items-center justify-content-center gap-4">
          <img 
            src="/logo.png" 
            alt="Shravan Audiobooks Logo" 
            className="shravan-audiobooks-logo" 
          />
          <div>
            <h1 className="text-center text-xl font-bold">Shravan Audiobooks Library</h1>
            <p className="text-center">A NAB Delhi innovation. Supported by United Way Delhi</p>
          </div>
      </div>

      <div className='d-flex flex-column mt-5 justify-content-center align-items-start category-container'>

        <div className='d-flex flex-row flex-wrap justify-content-end align-items-center w-100'>
          <h2 className='me-3 my-auto text-left language-font'>Select a language</h2>
          <select className='form-select w-auto' value={selectedLanguage} onChange={handleLanguageChange}>
            {
              languages && languages.map((lang) => (
                <option key={lang.language.toLowerCase()} value={lang.language}>
                  {lang.language}
                </option>
              ))
            }
          </select>
        </div>

        <div className='d-flex flex-row flex-wrap justify-content-between align-items-center w-100'>
          <h2 className='me-3 text-left'>Choose one category</h2>
          <ul className='list-group category-list w-100'>
            <li key='cat-1' className='list-group-item category-item'>
              <Link
                to={`/category/other/${categories[0]}`}
                onClick={() => { handleCategoryClick(categories[0]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>1. {categories[0]}</p>
                </div>
              </Link>
            </li>

            <li key='cat-2' className='list-group-item category-item'>
              <Link
                to={`/category/other/${categories[1]}`}
                onClick={() => { handleCategoryClick(categories[1]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>2. {categories[1]}</p>
                </div>
              </Link>
            </li>

            <li key='cat-3' className='list-group-item category-item'>
              <Link
                to={`/category/other/${categories[2]}`}
                onClick={() => { handleCategoryClick(categories[2]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>3. {categories[2]}</p>
                </div>
              </Link>
            </li>

            {/* <li key='cat-4' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/other/${categories[3]}`}
                onClick={() => { handleCategoryClick(categories[3]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>4. {categories[3]}</p>
                </div>
              </Link>
            </li> */}

            <li key='cat-4' className='list-group-item category-item'>
              <Link
                to={`/news`}
                onClick={() => { handleCategoryClick(categories[3]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>4. {categories[3]}</p>
                </div>
              </Link>
            </li>

            <li key='cat-4' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/other/${categories[4]}`}
                onClick={() => { handleCategoryClick(categories[4]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>5. {categories[4]}</p>
                </div>
              </Link>
            </li>

            <li key='cat-5' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/books`}
                onClick={() => { handleCategoryClick('books') }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>6. Books</p>
                </div>
              </Link>
            </li>
          </ul>
        </div>
        {loading && <p>Loading books...</p>}
        {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      </div >
    </div >
  );
}

export default CategoryPage;